<template>
	<div class="DiFangZhi" @click="frameonoff = false; provinceframeonoff = false">
		<!--地方志的头部-->
		<Header1></Header1>
		<div class="DiFangZhiHeader">当前位置：<span @click="homePage">首页</span> > <span @click="difangzhiPage">地方志</span></div>
		<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
			<span>版权保护,该方志暂不开放,查看内容详情请联系数据库管理员,欢迎您来我院现场参观浏览</span>
			<span>联系电话:027-67868953</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">确定</el-button>
				<el-button type="primary" @click="dialogVisible = false">取消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="catVisible" width="30%">
			<span>您尚未登录，请登录查看</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="$router.push('/login') ">确定</el-button>
				<el-button @click="catVisible = false">取消</el-button>
			</span>
		</el-dialog>
		<div class="Index">
			<div class="IndexLeft" style="position:relative;overflow:visible;">
				<div class="IndexLeftTitle" v-if="isroll == 1" style="">
					地方志：
					<span v-text="HistoryCount1"></span>
					册
				</div>
				<div class="IndexLeftTitle" v-if="isroll == 2" style="">
					地方志：
					<span v-text="HistoryCount2"></span>
					卷
				</div>
				<div v-if="menuList.length > 0">
					<div style="border: 1px solid rgb(236, 232, 232);cursor: pointer;">
						<div class="FontTitle" @click="show1 = !show1">
							<div>{{ menuList[0].title }}</div>
							<div class="icon01 iconbase" :class="{ icon02: show1 }"></div>
						</div>
						<div v-if="show1">
							<el-checkbox-group v-model="selectdata1" style="overflow-y:auto;max-height:168px;" @change="getList">
								<el-checkbox class="ItemLest" v-for="item in menuList[0].value" :label="item.name" :key="item.name" :value="item.name">
									<label style="font-size: 12px; ">{{ item.name }}({{item.num}})</label>
								</el-checkbox>
							</el-checkbox-group>
						</div>
					</div>
					<div class="years dfzyear" style="cursor: pointer; border: 1px solid rgb(236, 232, 232); margin-top: 3px;">
						<div class="FontTitle" @click="show2 = !show2">
							<div>{{ menuList[1].title }} </div>
							<div class="icon01 iconbase" :class="{ icon02: show2 }"></div>
						</div>
						<div v-if="show2">
							<div style="margin-left: 5px">
								<el-checkbox-group v-model="radio">
									<div v-for="(item,index) in menuList[1].yearValue" @change="showFrame(menuList[1].yearValue,item.title)" style="padding: 5px">
										<el-checkbox :label="item.title"></el-checkbox>
										<span @click="showList(menuList[1].yearValue, item)" style="cursor: pointer;font-size: 12px" @click.stop>
											{{item.title}}
											({{item.num}})
										</span>
									</div>
								</el-checkbox-group>
							</div>
						</div>
						<div style=" position:absolute;left:190px;bottom: -175px;z-index:1000;background-color:rgb(251, 251, 251);" class="frame"
						 v-if="frameonoff" @click.stop>
							<div style="border: 1px solid rgb(255, 231, 231);" v-for="(item, index) in yearsinfos" v-if="showForm === item.title"
							 :key="index">
								<el-checkbox-group v-model="selectdata2" style="min-height:150px;overflow-y:auto;max-height:310px;width:150px;"
								 @change="cjlist">
									<el-checkbox class="ItemLest" v-for="itema in item.value" :label="itema.name" :key="index" :value="itema.name"
									 @change="cengjichar(itema,item.value,index)">
										<label style="font-size: 12px; ">{{ itema.name}}</label>
									</el-checkbox>
								</el-checkbox-group>
							</div>
						</div>
					</div>
					<div class="province dfzprovince" style="cursor: pointer; border: 1px solid rgb(236, 232, 232); margin-top: 3px;">
						<div class="FontTitle" @click="show3 = !show3">
							<div>{{ menuList[2].title }}</div>
							<div class="icon01 iconbase" :class="{ icon03: show3 }"></div>
						</div>
						<div v-if="show3">
							<div style="margin-left: 5px">
								<el-checkbox-group v-model="provinceCheck">
									<div v-for="(item,index) in menuList[2].value" :key="index" @change="provinceshowFrame(item,item.name)" style="padding: 5px">
										<el-checkbox :label="item.name"></el-checkbox>
										<span @click="showProvince(item)" style="cursor: pointer;font-size: 12px" @click.stop>
											{{item.name}} ({{item.num}})
										</span>
									</div>
								</el-checkbox-group>
							</div>
						</div>
						<div style="position:absolute;left:190px;bottom:40px;z-index:1000;background-color:rgb(251, 251, 251);" class="proviceframe"
						 v-if="provinceframeonoff" @click.stop>
							<div style="border: 1px solid rgb(255, 231, 231);" v-for="(item, index) in provinces" v-if="provinceshowForm === item.title"
							 :key="index">
								<el-checkbox-group v-model="selectdata3" style="min-height:150px;overflow-y:auto;max-height:310px;width:180px;">
									<el-checkbox class="ItemLest" v-for="itema in item.value" :label="itema.name" :key="itema.name" :value="itema.name"
									 @change="diquchar(itema,item.value,index)">
										<label style="font-size: 12px; ">{{ itema.name }}</label>
									</el-checkbox>
								</el-checkbox-group>
							</div>
						</div>
					</div>
					<div style="cursor: pointer; border: 1px solid rgb(236, 232, 232); margin-top: 3px;" v-show="isroll==2">
						<div class="FontTitle" @click="show4 = !show4">
							<div>{{ menuList[3].title }} </div>
							<div class="icon01 iconbase" :class="{ icon02: show4 }"></div>
						</div>
						<div v-if="show4">
							<el-checkbox-group v-model="selectdata4" style="max-height:120px;" @change="getList">
								<el-checkbox class="ItemLest" v-for="item in menuList[3].value" :label="item.name" :key="item.name" :value="item.name">
									<label style="font-size: 12px; ">{{ item.name}} ({{item.num}})</label>
								</el-checkbox>
							</el-checkbox-group>
						</div>
					</div>
				</div>
			</div>

			<div class="IndexRight" v-loading="loading2" element-loading-text="精彩即将呈现..." element-loading-spinner="el-icon-loading"
			 element-loading-background="rgba(200, 200, 200, 0.1)">
				<div style="display:flex;margin:10px 0;">
					<div style="width:100px;">
						<el-select v-model="query.searchType" placeholder="请选择" @change="getList" style="width:107px;line-height:40px;">
							<el-option v-for="item in searhtypeItem" :key="item.id" :value="item.id" :label="item.title"></el-option>
						</el-select>
					</div>
					<div style="flex:1;margin:0 10px;">
						<el-input @keyup.enter.native="keyEnter" placeholder="请输入关键字" prefix-icon="el-icon-search" v-model="query.searchName"></el-input>
					</div>
					<div @click="searchbycondition" class="searchbtn">搜索</div>
				</div>
				<div style="width:100%;border:solid 1px rgba(236, 234, 234, 1);padding:5px 0;">
					<div class="IndexRightHeaderTop">
						<div class="search_header">
							<el-switch v-model="isroll" style="display: none;" active-color="#23c6a9" inactive-color="#55a7ba" @change="getList"
							 active-value="1" inactive-value="2"></el-switch>
							<label style="display: none;" v-if="isroll == 1">册</label>
							<label style="display: none;" v-if="isroll == 2">卷</label>
							<div class="icon_box" style="color: #1098aa;">
								<span @click="toggleDateType(1)" style="cursor: pointer;">
									<i class="el-icon-date" style="margin-left: 10px; " aria-hidden="true">全部</i>
								</span>
								<span @click="toggleDateType(4)" style="cursor: pointer;">
									<i class="el-icon-date" style="margin-left: 10px;" aria-hidden="true">最近一周</i>
								</span>
								<span @click="toggleDateType(2)" style="cursor: pointer;">
									<i class="el-icon-date" style="margin-left: 10px;" aria-hidden="true">最近一月</i>
								</span>
								<span @click="toggleDateType(3)" style="cursor: pointer;">
									<i class="el-icon-date" style="margin-left: 10px;" aria-hidden="true">最近三月</i>
								</span>

							</div>
							<div class="right">
								<div class="sortClass" style="color: #1098aa;">
									<el-button class="sortClass" size="mini" @click="toggleUpbyYear(1)" v-show="yearFlag === 0" icon="el-icon-upload2">年份</el-button>
									<el-button class="sortClass" size="mini" @click="toggleUpbyYear(0)" v-show="yearFlag === 1" icon="el-icon-download">年份</el-button>
								</div>
								<div class="sortClass" style="color: #1098aa;">
									<el-button class="sortClass" size="mini" @click="toggleUpbyPublicYear(1)" v-show="publicyearFlag === 0" icon="el-icon-upload2">发布年份</el-button>
									<el-button class="sortClass" size="mini" @click="toggleUpbyPublicYear(0)" v-show="publicyearFlag === 1" icon="el-icon-download">发布年份</el-button>
								</div>
								<div class="icon_box" style="color: #1098aa;">
									<span @click="showTable = true">
										<el-button size="mini">表格</el-button>
									</span>
									<span @click="showTable = false">
										<el-button size="mini">列表</el-button>
									</span>
								</div>
							</div>
						</div>
						<div class="DisLi">
							<div style="width: 100%" v-if="selectdata1.length > 0" class="item">
								<span class="title">地区层级</span>
								<div value="x" class="item DIming" v-for="(item, index) in selectdata1" :key="index">
									<button class="itemButton" @click="del('selectdata1', item)">{{item}} &nbsp;<i class="el-icon-close"></i></button>
								</div>
							</div>
							<div style="width: 94%" v-if="cjtag.length > 0" class="item">
								<span class="title">年代层级</span>
								<el-tag :key="item" v-for="item in cjtag" style=" padding-left: 5px; padding-right: 5px;" closable
								 :disable-transitions="false" @close="delltag(item)">{{item}}</el-tag>
								<!-- @close="CloseProvince(areatag)" -->
								<!-- <div value="x" class="item DIming" v-for="(item, index) in selectdata22" :key="index" v-show="selectdata22 != '' "> 
									<button class="itemButton" @click="del('selectdata22', item)">{{item}} &nbsp;<i class="el-icon-close"></i></button>
								</div>
								<div value="x" class="item DIming" v-for="(item, index) in selectdata2" :key="index" v-show="selectdata22 == '' ">
									<button class="itemButton" @click="del('selectdata2', item)">{{item}} &nbsp;<i class="el-icon-close"></i></button>
								</div> -->

							</div>
							<div style="width: 92%" v-if="diqutag.length > 0" class="item">
								<span class="title">省份</span>
								<div value="x" class="item DIming" v-for="(item, index) in diqutag" :key="index">
									<button class="itemButton" @click="deldiqutag(item)">{{item}} &nbsp;<i class="el-icon-close"></i></button>
								</div>
							</div>
							<div style="width: 95%" v-if="selectdata4.length > 0" class="item">
								<span class="title">分类</span>
								<div value="x" class="item DIming" v-for="(item, index) in selectdata4" :key="index">
									<button class="itemButton" @click="del('selectdata4', item)">{{item}} &nbsp;<i class="el-icon-close"></i></button>
								</div>
							</div>
							<span class="deleteAll" @click="deleteAll" v-if="selectdata1.length > 0 ||selectdata2.length > 0||selectdata3.length > 0||selectdata4.length > 0 || cjtag.length >0 ||diqutag.length > 0"
							 style="color: #f0a023;font-size: 13px;    display: block;text-align: right;">
								<i class="el-icon-delete"></i>
								删除所有
							</span>
						</div>
					</div>
					<div v-if="page.content.length > 0" v-show="isroll == 1">
						<div v-show="!showTable" class="IndexRightIndex" v-for="(item, index) in page.content" :key="index" style="width:98%;margin:0 auto;">
							<div class="IndexRightIndexNeiRong">
								<div class="IndexRightIndexNeiRongRight" style="flex:1; margin-left: 20px;">
									<div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-left: 10px;">{{ item.volumename }}</div>
									<div class="IndexRightIndexNeiRongRightTitle">
										<span class="contentitem1" :title="item.areaname">地区名称:{{ item.areaname }}</span>
										<span class="contentitem1" :title="item.arealevel">地区层级:{{item.arealevel}}</span>
										<span class="contentitem1" :title="item.year">年份:{{ item.year }}</span>
										<span class="contentitem1" :title="item.yearlevel">年代层级:{{ item.yearlevel }}</span>
									</div>
									<div>
										<span class="contentitem">省份:{{ item.province }}</span>
										<!--发布年份：{{ item.publishyear }}-->
										<span class="contentitem">卷数:{{item.rollNumber}}</span>
									</div>
									<!-- <div>阅读全文</div> -->
								</div>
								<div>
									<div class="fl" style="margin-top:30px;margin-right:5px; display: none;">
										<img src="../assets/Img/icon_star01.png" :class="{animated: item.statue,heartBeat: item.statue}" style="width:25px;height:25px;"
										 v-if="staronoff" key="0" />
										<img src="../assets/Img/icon_star02.png" class="animated heartBeat" alt="" style="width:25px;height:25px;"
										 v-else key="1" />
									</div>
									<div class="fr catbtn" @click="catVolume(item)">查看</div>
								</div>
							</div>
						</div>
						<div v-show="showTable">
							<el-table :data="page.content" width="100%">

								<el-table-column show-overflow-tooltip tooltip-effect="light" fixed prop="volumename" label="册名" width="180">
									<template slot-scope="scope">
										<span @click="$router.push('/DiFangZhiNeiRong1?id=' + scope.row.id)" style="cursor: pointer;" size="small">{{scope.row.volumename}}
										</span>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip tooltip-effect="light" prop="areaname" label="地区名称"></el-table-column>
								<el-table-column show-overflow-tooltip tooltip-effect="light" prop="province" label="省份"></el-table-column>
								<el-table-column show-overflow-tooltip tooltip-effect="light" prop="year" label="年份"></el-table-column>
								<el-table-column show-overflow-tooltip tooltip-effect="light" prop="yearlevel" label="年代层级"></el-table-column>
								<el-table-column show-overflow-tooltip tooltip-effect="light" prop="publishyear" label="出版年份"></el-table-column>
								<el-table-column show-overflow-tooltip tooltip-effect="light" prop="rollNumber" label="卷数"></el-table-column>
							</el-table>
						</div>
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
						 :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="currentTotal">
						</el-pagination>
					</div>
					<div v-if="page.content.length > 0" v-show="isroll==2">
						<div v-show="!showTable" class="IndexRightIndex" v-for="(item, index) in page.content" :key="index" style="width:98%;margin:0 auto;">
							<div class="IndexRightIndexNeiRong">
								<div class="IndexRightIndexNeiRongRight" style="flex:1; margin-left: 20px;">
									<div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-left: 10px;">{{ item.rollname }}</div>
									<div>
										<span class="contentitem1">地区名称:{{ item.areaname }}</span>
										<span class="contentitem1">地区层级:{{item.arealevel}}</span>
										<span class="contentitem1">成书年份:{{ item.year }}</span>
										<span class="contentitem1">年代层级:{{ item.yearlevel }}</span>
									</div>
									<div>
										<span class="contentitem">省份:{{ item.province }}</span>
										<!--出版年份：{{ item.publishyear }}-->
										<span class="contentitem">页数:{{ item.pagenumber }}</span>

									</div>
									<!-- <div>阅读全文</div> -->
								</div>
								<div>
									<div class="fl" style="margin-top:30px;margin-right:5px; display: none;">
										<img src="../assets/Img/icon_star01.png" :class="{	animated: item.statue,heartBeat: item.statue}" alt=""
										 style="width:25px;height:25px;" v-if="staronoff" key="0" />
										<img src="../assets/Img/icon_star02.png" class="animated heartBeat" alt="" style="width:25px;height:25px;"
										 v-else key="1" />
									</div>
									<div class="fr catbtn" @click="catRoll(item)">查看</div>
								</div>
							</div>
						</div>
						<div v-show="showTable">
							<el-table :data="page.content" width="100%" :row-class-name="tableRowClassName">
								<el-table-column type="index" label="序号" :index="indexMethod"></el-table-column>
								<el-table-column show-overflow-tooltip tooltip-effect="light" prop="rollname" label="卷名" width="200">
									<template slot-scope="scope">
										<span @click="catRoll(scope.row)" style="cursor: pointer;" size="small">{{scope.row.rollname}}
										</span>
									</template>
								</el-table-column>
								<el-table-column show-overflow-tooltip tooltip-effect="light" prop="areaname" label="地区名称" width='180'></el-table-column>
								<el-table-column show-overflow-tooltip tooltip-effect="light" prop="province" label="地区层级"></el-table-column>
								<el-table-column show-overflow-tooltip tooltip-effect="light" prop="year" label="成书年份"></el-table-column>
								<el-table-column show-overflow-tooltip tooltip-effect="light" prop="yearlevel" label="年代层级"></el-table-column>
								<!-- <el-table-column show-overflow-tooltip tooltip-effect="light" prop="publishyear" label="发布年份" ></el-table-column> -->
								<el-table-column show-overflow-tooltip tooltip-effect="light" prop="pagenumber" label="页数"></el-table-column>

								<!-- <el-table-column fixed="right" width="100" label="操作">
					                <template slot-scope="scope">
					                    <el-button @click="catRoll(scope.row)"
					                               type="primary" icon="el-icon-search" size="small">查看
					                    </el-button>
					                </template>
					            </el-table-column> -->
							</el-table>
						</div>
						<!-- <Pager :page="page" @load="getList"></Pager> -->
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
						 :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="currentTotal">
						</el-pagination>
					</div>
					<div v-else class="no_data">暂无数据</div>
				</div>
			</div>
			<div class="IndexRightafter">
				<div style="color: rgb(29, 142, 127);font-size: 14px;text-align: center; padding: 15px 0; background-color: #ecf2f2; padding-left: 5px;">
					地方志数量分布
				</div>
				<div v-show="barChart == 2" id="myChart" style="width:250px; height:220px; border: 1px solid rgb(241, 241, 241); margin-top: 15px;"></div>
				<div v-show="barChart == 1" id="barChart" style="width:250px; height:220px; border: 1px solid rgb(241, 241, 241); margin-top: 15px;"></div>

				<div style="margin: 0 60px">
					<el-switch v-model="barChart" active-color="#23c6a9" inactive-color="#55a7ba" active-value="1" inactive-value="2">
					</el-switch>
					<label v-if="barChart == 2" style="margin-left: 10px;font-size: 12px">按地区统计</label>
					<label v-if="barChart == 1" style="margin-left: 10px;font-size: 12px">按年代统计</label>
				</div>
				<div style="color: rgb(29, 142, 127);font-size: 14px;text-align: center; margin-top: 15px; padding: 15px 0; background-color: #ecf2f2; padding-left: 5px;">
					最新地方志
				</div>
				<div style="width:100%;box-sizing:border-box;padding-left:5px;">
					<div v-for="data in newLcData" class="clearfix box" style="margin-top:10px;">
						<div @click="catRoll(data)">
							<img src="../assets/Img/bookpage.png" style="width:40px;height:64px; margin-top: 4px;" />
						</div>
						<div class="lc_item" @click="catRoll(data)">
							<div style="width:150px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis; margin-top: 5px;">{{data.rollname}}</div>
							<div style="margin:4px 0;">出版单位：{{data.publisher}}</div>
							<div style="width:150px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">发布年份：{{data.publishyear}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <Foot></Foot> -->
	</div>
</template>
<script>
	// import {DiFangZhiData, yearsinfo} from '../assets/Data.js';
	import {
		request
	} from '../API/ApiUrl.js';
	import $ from 'jquery';
	import Header1 from '../components/Header1.vue';
	// import Foot from '../components/Foot.vue';
	import Pager from '../components/Pager'

	let echarts = require('echarts/lib/echarts');
	require('echarts/lib/chart/bar');
	export default {
		components: {
			Header1
			// Foot
		},
		data() {
			return {
				mg: '',
				q: '',
				yh: '',
				md: '',
				bx: '',
				provinceCheck: [],
				qx: false,
				radio: [],
				loading2: false, //false不显示loading，true显示loading
				yearsinfos: [],
				provinces: [],
				selectdata1: [],
				selectdata2: [],
				selectdata22: [], //年代层级全选显示
				selectdata3: [],
				selectdata4: [],
				barChart: 1, //判断是按地区还是年代统计
				isroll: 2, //判断查看是否册还是卷
				datetype: 1, //1全部，2最近一周，3一个月，4最近三月
				yearFlag: 0, //0默认升序1降序
				publicyearFlag: 0, //0默认升序1降序
				select2datalist: [{
						value: '0',
						label: '默认'
					},
					{
						value: '1',
						label: '年代'
					},
					{
						value: '2',
						label: '发布年份'
					}
				],
				searhtypeItem: [{
						id: 'buxian',
						title: '不限'
					},
					{
						id: 'areaname1',
						title: '地区名称'
					},
					{
						id: 'name1',
						title: '册名/卷名'
					}
				],
				staronoff: false,
				frameTop: '400px',
				frameonoff: false,
				provinceframeonoff: false,
				HistoryCount1: 0, //地方志册的数
				HistoryCount2: 0, //地方志卷的数
				dialogVisible: false, //false不现实true显示
				catVisible: false,
				showForm: '',
				provinceshowForm: '',
				chartXData: [],
				chartXData1: [],
				chartData: [],
				chartData1: [],
				newLcData: [],
				menuList: [],
				index: 0,
				datalist1: [],
				datalist2: [],
				datalist3: [],
				datalist4: [],
				provinceList1: [],
				provinceList2: [],
				provinceList3: [],
				provinceList4: [],
				provinceList5: [],
				provinceList6: [],
				provinceList7: [],
				show1: false,
				show2: false,
				show3: false,
				show4: false,
				show5: false,
				show6: false,
				query: {
					select2data: '0', //搜索下拉框选中数据
					searchName: '', //关键字名
					searchType: 'buxian' //搜索类型
				},
				showTable: false,
				page: {
					content: []
				},
				currentPage: 1,
				pageSize: 10,
				currentTotal: 0,
				loginData: '',
				arr: {
					searchName1: "",
					selectdata1: "",
					selectdata2: "",
					selectdata3: "",
					selectdata4: ""
				},
				data1: {
					searchName1: "",
					selectdata1: "",
					selectdata2: "",
					selectdata3: "",
					selectdata4: ""
				},
				y: [],
				mgall: [],
				qall: [],
				yhall: [],
				mdall: [],
				bxall: [],
				arr22: [],
				dx: '',
				mgtag: [],
				qtag: [],
				bxtag: [],
				yhtag: [],
				mdtag: [],
				cjtag: [],

				diqutag: [],
				xntag: [],
				xbtag: [],
				hntag: [],
				hbtag: [],
				hztag: [],
				hdtag: [],
				dbtag: [],
				xn: '',
				xb: '',
				hn: '',
				hb: '',
				hz: '',
				hd: '',
				db: '',
				xnall: [],
				xball: [],
				hnall: [],
				hball: [],
				hzall: [],
				hdall: [],
				dball: [],

			};
		},
		computed: {

			getToken: function() {
				return this.$store.state.DiFangZhi;
			},
			//地区层级
			arealevel: function() {
				return this.selectdata1.join(',')
			},

			//省份
			// province: function() {
			// 	return this.selectdata3.join(',')
			// },
			//地方志
			rolltype: function() {
				return this.selectdata4.join(',')
			}
		},
		watch: {
			selectdata3(val) {
				//console.log(val,'selectdata3')
			},
			mgall() {
				this.selectdata2 = this.mgall.concat(this.mdall.concat(this.yhall.concat(this.bxall.concat(this.qall))))
			},
			mdall() {
				this.selectdata2 = this.mgall.concat(this.mdall.concat(this.yhall.concat(this.bxall.concat(this.qall))))
			},
			bxall() {
				this.selectdata2 = this.mgall.concat(this.mdall.concat(this.yhall.concat(this.bxall.concat(this.qall))))
			},
			qall() {
				this.selectdata2 = this.mgall.concat(this.mdall.concat(this.yhall.concat(this.bxall.concat(this.qall))))
			},
			yhall() {
				this.selectdata2 = this.mgall.concat(this.mdall.concat(this.yhall.concat(this.bxall.concat(this.qall))))
			},
			mgtag(val) {
				this.cjtag = this.mgtag.concat(this.qtag.concat(this.bxtag.concat(this.mdtag.concat(this.yhtag))))
			},
			yhtag(val) {
				this.cjtag = this.mgtag.concat(this.qtag.concat(this.bxtag.concat(this.mdtag.concat(this.yhtag))))
			},
			mdtag(val) {
				this.cjtag = this.mgtag.concat(this.qtag.concat(this.bxtag.concat(this.mdtag.concat(this.yhtag))))
			},
			bxtag(val) {
				this.cjtag = this.mgtag.concat(this.qtag.concat(this.bxtag.concat(this.mdtag.concat(this.yhtag))))
			},
			qtag(val) {
				this.cjtag = this.mgtag.concat(this.qtag.concat(this.bxtag.concat(this.mdtag.concat(this.yhtag))))
			},
			xnall() {
				this.selectdata3 = this.xnall.concat(this.xball.concat(this.hnall.concat(this.hball.concat(this.hball.concat(this.hzall
					.concat(this.hdall.concat(this.dball)))))))
			},
			xball() {
				this.selectdata3 = this.xnall.concat(this.xball.concat(this.hnall.concat(this.hball.concat(this.hball.concat(this.hzall
					.concat(this.hdall.concat(this.dball)))))))
			},
			hnall() {
				this.selectdata3 = this.xnall.concat(this.xball.concat(this.hnall.concat(this.hball.concat(this.hball.concat(this.hzall
					.concat(this.hdall.concat(this.dball)))))))
			},
			hball() {
				this.selectdata3 = this.xnall.concat(this.xball.concat(this.hnall.concat(this.hball.concat(this.hball.concat(this.hzall
					.concat(this.hdall.concat(this.dball)))))))
			},
			hzall() {
				this.selectdata3 = this.xnall.concat(this.xball.concat(this.hnall.concat(this.hball.concat(this.hball.concat(this.hzall
					.concat(this.hdall.concat(this.dball)))))))
			},
			hdall() {
				this.selectdata3 = this.xnall.concat(this.xball.concat(this.hnall.concat(this.hball.concat(this.hball.concat(this.hzall
					.concat(this.hdall.concat(this.dball)))))))
			},
			dball() {
				this.selectdata3 = this.xnall.concat(this.xball.concat(this.hnall.concat(this.hball.concat(this.hball.concat(this.hzall
					.concat(this.hdall.concat(this.dball)))))))
			},
			xntag() {
				this.diqutag = this.xntag.concat(this.xbtag.concat(this.hntag.concat(this.hbtag.concat(this.hztag.concat(this.hdtag
					.concat(this.dbtag))))))
			},
			xbtag() {
				this.diqutag = this.xntag.concat(this.xbtag.concat(this.hntag.concat(this.hbtag.concat(this.hztag.concat(this.hdtag
					.concat(this.dbtag))))))
			},
			hntag() {
				this.diqutag = this.xntag.concat(this.xbtag.concat(this.hntag.concat(this.hbtag.concat(this.hztag.concat(this.hdtag
					.concat(this.dbtag))))))
			},
			hbtag() {
				this.diqutag = this.xntag.concat(this.xbtag.concat(this.hntag.concat(this.hbtag.concat(this.hztag.concat(this.hdtag
					.concat(this.dbtag))))))
			},
			hztag() {
				this.diqutag = this.xntag.concat(this.xbtag.concat(this.hntag.concat(this.hbtag.concat(this.hztag.concat(this.hdtag
					.concat(this.dbtag))))))
			},
			hdtag() {
				this.diqutag = this.xntag.concat(this.xbtag.concat(this.hntag.concat(this.hbtag.concat(this.hztag.concat(this.hdtag
					.concat(this.dbtag))))))
			},
			dbtag() {
				this.diqutag = this.xntag.concat(this.xbtag.concat(this.hntag.concat(this.hbtag.concat(this.hztag.concat(this.hdtag
					.concat(this.dbtag))))))
			},

		},

		created() {
			// this.getListReportCond();
			// this.query.searchName = this.$route.query.keywords;


		},
		mounted() {
			if (sessionStorage.loginData) {
				this.loginData = JSON.parse(sessionStorage.loginData);
			}
			debugger;
			if(this.loginData == ""){
				this.$router.push("/login")
			}
			this.query.searchName = this.$route.query.keywords;
			// debugger;
			console.log("1111", this.$route.query.searchType);
			// this.query.searchType = this.$route.query.searchType === 'areaname' ? 'areaname1' : '';
			this.query.searchType = "buxian";
			this.getList();
			this.getHistoryCount1();
			this.getHistoryCount2();
			this.getChartData();
			this.getNewLcData();
			this.getYearLevel();
			this.getProvinceLevel();
			this.getYearLevelReport();
			this.addVisit();
		},
		methods: {
			delltag(val) {
				//console.log(val,this.cjtag)

				if (val == '民国') {
					this.mgall = []
					this.radio.splice(this.radio.indexOf('民国'), 1)
				} else if (val == '不详') {
					this.bxall = []
					this.radio.splice(this.radio.indexOf('不详'), 1)

				} else if (val == '明代及以前') {
					this.mdall = []

					this.radio.splice(this.radio.indexOf('明代及以前'), 1)

				} else if (val == '1949年以后') {
					this.yhall = []

					this.radio.splice(this.radio.indexOf('1949年以后'), 1)

				} else if (val == '清') {
					this.qall = []
					this.radio.splice(this.radio.indexOf('清'), 1)

				}
				this.cjtag.splice(this.cjtag.indexOf(val), 1)
				this.selectdata2.splice(this.selectdata2.indexOf(val), 1)

				setTimeout(() => {
					this.getList()
				}, 100)
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				// //console.log(row, rowIndex)
				if (rowIndex % 2 == 1) {
					return 'warning-row';
				} else {
					return 'success-row';
				}
			},
			indexMethod(index) {
				return index + 1 + (this.currentPage - 1) * this.pageSize;
			},
			//增加点击量
			addVisit() {
				request('/apiVisit/addVisitData', {
					module: 101
				}).then(res => {

				})
			},
			searchbycondition() {
				this.currentPage = 1;
				this.getList();
			},
			//绑定回车
			keyEnter() {
				this.currentPage = 1;
				this.getList();
			},
			getYearLevelReport() {
				request('/apidfz/getYearLevelReport').then(res => {})
			},
			homePage() {
				this.$router.back("/index");
			},
			difangzhiPage() {
				this.$router.back("/DiFangZhi1");
			},

			catVolume(item) {
				let myDate = new Date();
				let tYear = myDate.getFullYear();
				//  //console.log()
				let pattern = /^[\u4e00-\u9fa5]/
				if (pattern.test(obj.year)) {
					//console.log(1);
				} else {
					//console.log(2);

				}
				if (obj.year > tYear - 50) {
					this.$message('当前文件还处于版权保护期,欢迎您来我院现场参观浏览!')
					return false;
				}
				this.$router.push('/DiFangZhiNeiRong1?id=' + item.id)
			},
			//查看卷详情
			catRoll(obj) {
				let myDate = new Date();
				let tYear = myDate.getFullYear();
				let flag = false;
				//console.log(obj.year)
				let pattern = /^[\u4e00-\u9fa5]/
				debugger
				if (pattern.test(obj.year)) {
					//console.log(1);
					flag = true;
				} else {
					//console.log(2);
					flag = false;
				}
				if(obj.year_sort == '不详'){
					
				} else if (obj.year >= tYear - 50 || !flag ) {
					this.$message('当前文件还处于版权保护期,欢迎您来我院现场参观浏览!')
					return false;
				}
				// //console.log(obj.ispure)
				if (this.loginData == "") {
					this.catVisible = true;
				} else if (obj.ispure == 1) {
					if (parseInt(obj.year) >= 1980) {
						this.dialogVisible = true;
					} else {
						if (this.isroll === 1) {
							//册
							this.$router.push('/DiFangZhiNeiRong1?id=' + obj.volumeid + '&isroll=' + this.isroll)
						} else {
							//卷
							this.$router.push('/DiFangZhiNeiRong1?id=' + obj.volumeid + '&isroll=' + this.isroll + "&vid=" + obj.id)
						}
					}
				} else if (this.loginData.isHaveAuth == 1) {
					this.$router.push('/DiFangZhiNeiRong1?id=' + obj.volumeid + '&isroll=' + this.isroll)
				} else {
					this.dialogVisible = true;
				}
				this.arr.searchName1 = this.query.searchName;
				this.arr.selectdata1 = this.selectdata1;
				this.arr.selectdata2 = this.selectdata2;
				this.arr.selectdata3 = this.selectdata3;
				this.arr.selectdata4 = this.selectdata4;
				localStorage.setItem("search", JSON.stringify(this.arr));
			},
			// 左侧菜单接口
			getListReportCond() {
				// request('/apidfz/listReportCond').then(res => {
				// 	if (res.code === 200) {
				//     this.menuList = res.data

				// 	} else {
				// 		this.$message({
				// 			message: res.msg,
				// 			type: 'error'
				// 		})
				// 	}
				// })
			},
			// 年代信息
			getYearLevel() {
				request('/apidfz/listYearLevelReport').then(res => {
					if (res.code === 200) {
						// //console.log(res.data);
						// this.yearsinfos = res.data
						// this.mg = res.data[0]
						// this.q = res.data[1]
						// this.yh = res.data[2]
						// this.md = res.data[3]
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},
			//获取省份信息
			getProvinceLevel() {
				request('/apidfz/listProGeolocationReport').then(res => {
					if (res.code === 200) {
						this.provinces = res.data
						this.db = res.data[0].value
						this.hb = res.data[1].value
						this.hn = res.data[2].value
						this.hd = res.data[3].value
						this.hz = res.data[4].value
						this.xn = res.data[5].value
						this.xb = res.data[6].value

					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},
			// 最新三条地方志
			getNewLcData() {
				request('/apidfz/localHistory3BookList').then(res => {
					if (res.code === 200) {
						this.newLcData = res.data
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},
			getList() {
				this.loading2 = true

				request('/apidfz/localHistoryBookList', {
					offset: this.currentPage,
					limit: this.pageSize,
					searchName: this.query.searchName,
					searchType: this.query.searchType,
					yearSort: this.yearFlag,
					publishyearSort: this.publicyearFlag,
					arealevel: this.arealevel,
					year: this.selectdata2.join(','),
					province: this.selectdata3.join(','),
					lctype: this.isroll,
					rolltype: this.rolltype,
					datetype: this.datetype,
					passflag: -1

				}).then(res => {
					// //console.log(this.selectdata2);
					if (res.code === 200) {
						this.loading2 = false;
						this.page.content = res.data.dfzlist;
						this.currentTotal = res.data.count;
						this.menuList = res.data.reportcondlist;
						this.yearsinfos = this.menuList[1].yearValue
						this.md = this.menuList[1].yearValue[0]
						this.q = this.menuList[1].yearValue[1]
						this.mg = this.menuList[1].yearValue[2]

						this.yh = this.menuList[1].yearValue[3]

						this.bx = this.menuList[1].yearValue[4]
					} else {
						this.loading2 = false;
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},
			//删除选中的所有的选项
			deleteAll() {
				this.selectdata1 = [];
				this.selectdata2 = [];
				this.selectdata22 = [];
				this.radio = [];
				this.cjtag = [];
				this.mdtag = [];
				this.mgtag = [];
				this.yhtag = [];
				this.qtag = [];
				this.bxtag = [];
				this.bxall = [];
				this.qall = [];
				this.mgall = [];
				this.mdall = [];
				this.yhall = [];
				this.diqutag = [];
				this.xnall = [];
				this.xball = [];
				this.hnall = [];
				this.hball = [];
				this.hzall = [];
				this.hdall = [];
				this.dball = [];
				this.xntag = [];
				this.xbtag = [];
				this.hntag = [];
				this.hbtag = [];
				this.hztag = [];
				this.hdtag = [];
				this.dbtag = [];
				this.selectdata3 = [];
				this.selectdata4 = [];
				this.arr.searchName1 = '';
				this.arr.selectdata1 = [];
				this.arr.selectdata2 = [];
				this.arr.selectdata3 = [];
				this.arr.selectdata4 = [];
				this.provinceCheck = [];
				this.datalist1 = [],
					this.datalist2 = [],
					this.datalist3 = [],
					this.datalist4 = [],
					this.provinceList1 = [],
					this.provinceList2 = [],
					this.provinceList3 = [],
					this.provinceList4 = [],
					this.provinceList5 = [],
					this.provinceList6 = [],
					this.provinceList7 = [],
					localStorage.removeItem("search");
				this.getList();
			},
			// 查询地方志册
			getHistoryCount1() {
				request('/apidfz/localHistoryCount?dtype=1').then(res => {
					if (res.code === 200) {
						this.HistoryCount1 = res.data;
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},
			//查询地方志卷
			getHistoryCount2() {
				request('/apidfz/localHistoryCount?dtype=2').then(res => {
					if (res.code === 200) {
						this.HistoryCount2 = res.data;
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},
			showList(item, index) {
				this.showForm = index.title;
				this.frameonoff = true;
			},

			cengjichar(val, val2, index) {
				console.log('cj', val, val2, index)
				if (index == 0) {
					if (this.mdall.indexOf(val.name) == -1) {
						this.mdtag.push(val.name)
						this.mdall.push(val.name)
					} else {
						this.mdtag.splice(this.mdtag.indexOf(val.name), 1)
						this.mdall.splice(this.mdall.indexOf(val.name), 1)
					}
					if (this.mdall.length == val2.length) {
						this.mdtag = ['明代及以前']
						this.radio.push('明代及以前')
					} else {
						if (this.radio.indexOf('明代及以前') != -1) {
							this.radio.splice(this.radio.indexOf('明代及以前'), 1)
						}
						for (var i = 0; i < this.mdall.length; i++) {
							if (this.mdtag.indexOf(this.mdall[i]) == -1) {
								this.mdtag.push(this.mdall[i])
							}
						}

					}
				} else if (index == 1) {
					if (this.qall.indexOf(val.name) == -1) {
						this.qtag.push(val.name)
						this.qall.push(val.name)
					} else {
						this.qtag.splice(this.qtag.indexOf(val.name), 1)
						this.qall.splice(this.qall.indexOf(val.name), 1)
					}
					if (this.qall.length == val2.length) {
						this.qtag = ['清']
						this.radio.push('清')
					} else {
						if (this.radio.indexOf('清') != -1) {
							this.radio.splice(this.radio.indexOf('清'), 1)
						}
						for (var i = 0; i < this.qall.length; i++) {
							if (this.qtag.indexOf(this.qall[i]) == -1) {
								this.qtag.push(this.qall[i])
							}
						}

					}
				} else if (index == 2) {
					if (this.mgall.indexOf(val.name) == -1) {
						this.mgtag.push(val.name)
						this.mgall.push(val.name)
					} else {
						this.mgtag.splice(this.mgtag.indexOf(val.name), 1)
						this.mgall.splice(this.mgall.indexOf(val.name), 1)
					}
					if (this.mgall.length == val2.length) {
						this.mgtag = ['民国']
						this.radio.push('民国')
					} else {
						if (this.radio.indexOf('民国') != -1) {
							this.radio.splice(this.radio.indexOf('民国'), 1)
						}
						for (var i = 0; i < this.mgall.length; i++) {
							if (this.mgtag.indexOf(this.mgall[i]) == -1) {
								this.mgtag.push(this.mgall[i])
							}
						}

					}
				} else if (index == 3) {
					if (this.yhall.indexOf(val.name) == -1) {
						this.yhtag.push(val.name)
						this.yhall.push(val.name)
					} else {
						this.yhtag.splice(this.yhtag.indexOf(val.name), 1)
						this.yhall.splice(this.yhall.indexOf(val.name), 1)
					}
					if (this.yhall.length == val2.length) {
						this.yhtag = ['1949年以后']
						this.radio.push('1949年以后')
					} else {
						if (this.radio.indexOf('1949年以后') != -1) {
							this.radio.splice(this.radio.indexOf('1949年以后'), 1)
						}
						for (var i = 0; i < this.yhall.length; i++) {
							if (this.yhtag.indexOf(this.yhall[i]) == -1) {
								this.yhtag.push(this.yhall[i])
							}
						}

					}
				} else if (index == 4) {
					if (this.bxall.indexOf(val.name) == -1) {
						this.bxtag.push(val.name)
						this.bxall.push(val.name)
					} else {
						this.bxtag.splice(this.bxtag.indexOf(val.name), 1)
						this.bxall.splice(this.bxall.indexOf(val.name), 1)
					}
					if (this.bxall.length == val2.length) {
						this.bxtag = ['不详']
						this.radio.push('不详')
					} else {
						if (this.radio.indexOf('不详') != -1) {
							this.radio.splice(this.radio.indexOf('不详'), 1)
						}
						for (var i = 0; i < this.bxall.length; i++) {
							if (this.bxtag.indexOf(this.bxall[i]) == -1) {
								this.bxtag.push(this.bxall[i])
							}
						}

					}
				}

				// for(var i = 0; i<val2.length;i++){
				//         if(val2[i] == val){
				//             if()
				//         }
				// }
				// for(var i =0;i<this.mg.value.length;i++){
				//     if(this.mg.value[i].name == val.name){
				//             if(this.mgall.indexOf(val.name) == -1){
				//                 this.mgtag.push(val.name)
				//                 this.mgall.push(val.name)
				//             }else{
				//               this.mgtag.splice(this.mgtag.indexOf(val.name),1)
				//               this.mgall.splice(this.mgall.indexOf(val.name),1)
				//             }
				//              // 全选
				//            if(this.mgall.length == this.mg.value.length){
				//                 console.log('全选')
				//                  this.mgtag = ['民国']
				//                  this.radio.push('民国')
				//            }else{
				//               console.log('没全选',this.mgall.length)
				//              if(this.radio.indexOf('民国') != -1){
				//                        this.radio.splice(this.radio.indexOf('民国'),1)
				//                      }
				//                      for(var i =0;i<this.mgall.length;i++){
				//                          if(this.mgtag.indexOf(this.mgall[i]) == -1){
				//                            this.mgtag.push(this.mgall[i])
				//                          }
				//                      }
				//            }
				//       }
				// }



				//  for(var i =0;i<this.md.value.length;i++){
				//       if(this.md.value[i].name == val.name){

				//               if(this.mdall.indexOf(val.name) == -1){
				//                   this.mdtag.push(val.name)
				//                   this.mdall.push(val.name)
				//               }else{
				//                 this.mdtag.splice(this.mdtag.indexOf(val.name),1)
				//                 this.mdall.splice(this.mdall.indexOf(val.name),1)
				//               }

				//                // 全选
				//              if(this.mdall.length == this.md.value.length){
				//                  //console.log('全选')
				//                    this.mdtag = ['明代及以前']
				//                     this.radio.push('明代及以前')
				//              }else{
				//                 //console.log('没全选',this.mdall.length)
				//                if(this.radio.indexOf('明代及以前') != -1){
				//                          this.radio.splice(this.radio.indexOf('明代及以前'),1)
				//                        }
				//                        for(var i =0;i<this.mdall.length;i++){
				//                            if(this.mdtag.indexOf(this.mdall[i]) == -1){
				//                              this.mdtag.push(this.mdall[i])
				//                            }
				//                        }
				//              }


				//         }


				//   }





				//     for(var i =0;i<this.bx.value.length;i++){
				//       if(this.bx.value[i].name == val.name){

				//               if(this.bxall.indexOf(val.name) == -1){
				//                   this.bxtag.push(val.name)
				//                   this.bxall.push(val.name)
				//               }else{
				//                 this.bxtag.splice(this.bxtag.indexOf(val.name),1)
				//                 this.bxall.splice(this.bxall.indexOf(val.name),1)
				//               }

				//                // 全选
				//              if(this.bxall.length == this.bx.value.length){
				//                  //console.log('全选')
				//                    this.bxtag = ['不详']
				//                       this.radio.push('不详')
				//              }else{
				//                 //console.log('没全选',this.bxall.length)
				//                if(this.radio.indexOf('不详') != -1){
				//                          this.radio.splice(this.radio.indexOf('不详'),1)
				//                        }
				//                        for(var i =0;i<this.bxall.length;i++){
				//                            if(this.bxtag.indexOf(this.bxall[i]) == -1){
				//                              this.bxtag.push(this.bxall[i])
				//                            }
				//                        }
				//              }


				//         }


				//   }

				//     for(var i =0;i<this.q.value.length;i++){
				//       if(this.q.value[i].name == val.name){

				//               if(this.qall.indexOf(val.name) == -1){
				//                   this.qtag.push(val.name)
				//                   this.qall.push(val.name)
				//               }else{
				//                 this.qtag.splice(this.qtag.indexOf(val.name),1)
				//                 this.qall.splice(this.qall.indexOf(val.name),1)
				//               }

				//                // 全选
				//              if(this.qall.length == this.q.value.length){
				//                  //console.log('全选')
				//                    this.qtag = ['清']
				//                     this.radio.push('清')
				//              }else{
				//                 //console.log('没全选',this.qall.length)
				//                       if(this.radio.indexOf('清') != -1){
				//                          this.radio.splice(this.radio.indexOf('清'),1)
				//                        }
				//                        for(var i =0;i<this.qall.length;i++){
				//                            if(this.qtag.indexOf(this.qall[i]) == -1){
				//                              this.qtag.push(this.qall[i])
				//                            }
				//                        }
				//              }


				//         }


				//   }

				// for(var i =0;i<this.yh.value.length;i++){
				//       if(this.yh.value[i].name == val.name){

				//               if(this.yhall.indexOf(val.name) == -1){
				//                   this.yhtag.push(val.name)
				//                   this.yhall.push(val.name)
				//               }else{
				//                 this.yhtag.splice(this.yhtag.indexOf(val.name),1)
				//                 this.yhall.splice(this.yhall.indexOf(val.name),1)
				//               }

				//                // 全选
				//              if(this.yhall.length == this.yh.value.length){
				//                  //console.log('全选')
				//                    this.yhtag = ['1949年以后']
				//                    this.radio.push('1949年以后')
				//              }else{
				//                 //console.log('没全选',this.yhall.length)
				//                if(this.radio.indexOf('1949年以后') != -1){
				//                          this.radio.splice(this.radio.indexOf('1949年以后'),1)
				//                        }
				//                        for(var i =0;i<this.yhall.length;i++){
				//                            if(this.yhtag.indexOf(this.yhall[i]) == -1){
				//                              this.yhtag.push(this.yhall[i])
				//                            }
				//                        }
				//              }


				//         }


				//   }


				//  setTimeout(()=>{
				//               this.getList()
				//             },100)



			},
			showFrame(item, names) {

				//console.log(item, names)
				// 如果选中民国则将其子类push到this.y(判断是否全选和父类对比长度的数组)
				if (this.radio.indexOf('民国') != -1) {
					// //console.log('2222')
					for (var i = 0; i < this.mg.value.length; i++) {

						if (this.mgall.indexOf(this.mg.value[i].name) == -1) {
							this.mgall.push(this.mg.value[i].name)
						} else {
							//console.log('删除民国')
							// this.mgall.splice(this.mgall.indexOf(this.mg.value[i].name),1)

						}
						//  if(this.mgtag.indexOf(this.mg.value[i].name) == -1){
						//       this.mgtag.push(this.mg.value[i].name)
						//   }else{
						//       this.mgtag.splice(this.mgtag.indexOf(this.mg.value[i].name) ,1)
						//   }
					}
					this.mgtag = ['民国']
				} else {
					//console.log('取消全选民国')
					this.mgtag = []
					this.mgall = []
					// if(this.mgtag.indexOf('民国') != -1){
					//     this.mgtag.splice(this.mgtag.indexOf('民国'), 1)
					//      for( var i=0;i<this.mg.value.length;i++){
					//       this.mgtag.splice(this.mgtag.indexOf(this.mg.value[i].name), 1)
					//       this.mgall.splice(this.mgall.indexOf(this.mg.value[i].name), 1)
					//      }
					// }
				}

				if (this.radio.indexOf('清') != -1) {
					for (var i = 0; i < this.q.value.length; i++) {
						// if(this.selectdata2.indexOf(this.q.value[i].name) == -1){
						//     this.selectdata2.push(this.q.value[i].name)
						// }else{
						//    this.selectdata2.splice(this.selectdata2.indexOf(this.q.value[i].name),1)
						// }
						if (this.qall.indexOf(this.q.value[i].name) == -1) {
							this.qall.push(this.q.value[i].name)
						} else {
							// this.qall.splice(this.qall.indexOf(this.q.value[i].name),1)

						}
						//  if(this.qtag.indexOf(this.q.value[i].name) == -1){
						//       this.qtag.push(this.q.value[i].name)
						//   }else{
						//       this.qtag.splice(this.qtag.indexOf(this.q.value[i].name) ,1)

						//   }
					}
					this.qtag = ['清']
				} else {
					this.qtag = []
					this.qall = []
					//console.log('取消全选清')
					// if(this.qtag.indexOf('清') != -1){
					//     //console.log('11111清')

					//     this.qtag.splice(this.qtag.indexOf('清'), 1)
					//      for( var i=0;i<this.q.value.length;i++){
					//       // this.selectdata2.splice(this.selectdata2.indexOf(this.q.value[i].name), 1)
					//       this.qtag.splice(this.qtag.indexOf(this.q.value[i].name), 1)
					//       this.qall.splice(this.qall.indexOf(this.q.value[i].name), 1)

					//      }
					// }
				}


				if (this.radio.indexOf('不详') != -1) {
					for (var i = 0; i < this.bx.value.length; i++) {
						// if(this.selectdata2.indexOf(this.bx.value[i].name) == -1){
						//     this.selectdata2.push(this.bx.value[i].name)
						// }else{
						//    this.selectdata2.splice(this.selectdata2.indexOf(this.bx.value[i].name),1)
						// }
						if (this.bxall.indexOf(this.bx.value[i].name) == -1) {
							this.bxall.push(this.bx.value[i].name)
						} else {
							// this.bxall.splice(this.bxall.indexOf(this.bx.value[i].name),1)

						}
						//  if(this.bxtag.indexOf(this.bx.value[i].name) == -1){
						//       this.bxtag.push(this.bx.value[i].name)
						//   }else{
						//       this.bxtag.splice(this.bxtag.indexOf(this.bx.value[i].name) ,1)

						//   }
					}
					this.bxtag = ['不详']
				} else {
					this.bxtag = []
					this.bxall = []
					//console.log('取消全选不详')
					// if(this.bxtag.indexOf('不详') != -1){
					//     this.bxtag.splice(this.bxtag.indexOf('不详'), 1)
					//      for( var i=0;i<this.bx.value.length;i++){
					//       // this.selectdata2.splice(this.selectdata2.indexOf(this.bx.value[i].name), 1)
					//       this.bxtag.splice(this.bxtag.indexOf(this.bx.value[i].name), 1)
					//       this.bxall.splice(this.bxall.indexOf(this.bx.value[i].name), 1)

					//      }
					// }
				}



				if (this.radio.indexOf('1949年以后') != -1) {
					for (var i = 0; i < this.yh.value.length; i++) {
						// if(this.selectdata2.indexOf(this.yh.value[i].name) == -1){
						//     this.selectdata2.push(this.yh.value[i].name)
						// }else{
						//    this.selectdata2.splice(this.selectdata2.indexOf(this.yh.value[i].name),1)
						// }
						if (this.yhall.indexOf(this.yh.value[i].name) == -1) {
							this.yhall.push(this.yh.value[i].name)
						} else {
							// this.yhall.splice(this.yhall.indexOf(this.yh.value[i].name),1)

						}
						//  if(this.yhtag.indexOf(this.yh.value[i].name) == -1){
						//       this.yhtag.push(this.yh.value[i].name)
						//   }else{
						//       this.yhtag.splice(this.yhtag.indexOf(this.yh.value[i].name) ,1)

						//   }
					}
					this.yhtag = ['1949年以后']
				} else {
					this.yhtag = []
					this.yhall = []
					//console.log('取消全选1949年以后')
					// if(this.yhtag.indexOf('1949年以后') != -1){
					//     this.yhtag.splice(this.yhtag.indexOf('1949年以后'), 1)
					//      for( var i=0;i<this.yh.value.length;i++){
					//       // this.selectdata2.splice(this.selectdata2.indexOf(this.yh.value[i].name), 1)
					//       this.yhtag.splice(this.yhtag.indexOf(this.yh.value[i].name), 1)
					//       this.yhall.splice(this.yhall.indexOf(this.yh.value[i].name), 1)

					//      }
					// }
				}

				if (this.radio.indexOf('明代及以前') != -1) {
					for (var i = 0; i < this.md.value.length; i++) {
						// if(this.selectdata2.indexOf(this.md.value[i].name) == -1){
						//     this.selectdata2.push(this.md.value[i].name)
						// }else{
						//    this.selectdata2.splice(this.selectdata2.indexOf(this.md.value[i].name),1)
						// }
						if (this.mdall.indexOf(this.md.value[i].name) == -1) {
							this.mdall.push(this.md.value[i].name)
						} else {
							// this.mdall.splice(this.mdall.indexOf(this.md.value[i].name),1)

						}
						//  if(this.mdtag.indexOf(this.md.value[i].name) == -1){
						//       this.mdtag.push(this.md.value[i].name)
						//   }else{
						//       this.mdtag.splice(this.mdtag.indexOf(this.md.value[i].name) ,1)

						//   }
					}
					this.mdtag = ['明代及以前']
				} else {
					//console.log('取消全选明代及以前')
					this.mdtag = []
					this.mdall = []
					// if(this.mdtag.indexOf('明代及以前') != -1){
					//     this.mdtag.splice(this.mdtag.indexOf('明代及以前'), 1)
					//      for( var i=0;i<this.md.value.length;i++){
					//       // this.selectdata2.splice(this.selectdata2.indexOf(this.md.value[i].name), 1)
					//       this.mdtag.splice(this.mdtag.indexOf(this.md.value[i].name), 1)
					//       this.mdall.splice(this.mdall.indexOf(this.md.value[i].name), 1)

					//      }
					// }
				}










				setTimeout(() => {
					this.getList()
				}, 100)

			},
			cjlist(val) {

				//  //console.log(val,'层级',this.dx)

			},

			//地区名称 选中
			showProvince(item) {
				//   
				//console.log("当前选中的省区")
				//console.log(item)
				this.provinceshowForm = item.name
				this.provinceframeonoff = true;
			},
			deldiqutag(val) {
				//console.log(val,this.diqutag)

				if (val == '西南') {
					this.xnall = []
					this.provinceCheck.splice(this.provinceCheck.indexOf('西南'), 1)
				} else if (val == '西北') {
					this.xball = []
					this.provinceCheck.splice(this.provinceCheck.indexOf('西北'), 1)

				} else if (val == '华南') {
					this.hnall = []

					this.provinceCheck.splice(this.provinceCheck.indexOf('华南'), 1)

				} else if (val == '华北') {
					this.hball = []

					this.provinceCheck.splice(this.provinceCheck.indexOf('华北'), 1)

				} else if (val == '华中') {
					this.hzll = []
					this.provinceCheck.splice(this.provinceCheck.indexOf('华中'), 1)

				} else if (val == '华东') {
					this.hdll = []
					this.provinceCheck.splice(this.provinceCheck.indexOf('华东'), 1)

				} else if (val == '东北') {
					this.dbll = []
					this.provinceCheck.splice(this.provinceCheck.indexOf('东北'), 1)

				}
				this.diqutag.splice(this.diqutag.indexOf(val), 1)
				this.selectdata3.splice(this.selectdata3.indexOf(val), 1)

				setTimeout(() => {
					this.getList()
				}, 100)
			},
			diquchar(val, val2, index) {
				console.log(val, val2, index)
				if (index == 0) {
					if (this.dball.indexOf(val.name) == -1) {
						this.dbtag.push(val.name)
						this.dball.push(val.name)
					} else {
						this.dbtag.splice(this.dbtag.indexOf(val.name), 1)
						this.dball.splice(this.dball.indexOf(val.name), 1)
					}
					if (this.dball.length == val2.length) {
						this.dbtag = ['东北']
						this.provinceCheck.push('东北')
					} else {
						if (this.provinceCheck.indexOf('东北') != -1) {
							this.provinceCheck.splice(this.provinceCheck.indexOf('东北'), 1)
						}
						for (var i = 0; i < this.dball.length; i++) {
							if (this.dbtag.indexOf(this.dball[i]) == -1) {
								this.dbtag.push(this.dball[i])
							}
						}

					}
				} else if (index == 1) {
					if (this.hball.indexOf(val.name) == -1) {
						this.hbtag.push(val.name)
						this.hball.push(val.name)
					} else {
						this.hbtag.splice(this.hbtag.indexOf(val.name), 1)
						this.hball.splice(this.hball.indexOf(val.name), 1)
					}
					if (this.hball.length == val2.length) {
						console.log('全选华北2')
						this.hbtag = ['华北']
						this.provinceCheck.push('华北')
					} else {
						if (this.provinceCheck.indexOf('华北') != -1) {
							this.provinceCheck.splice(this.provinceCheck.indexOf('华北'), 1)
						}
						for (var i = 0; i < this.hball.length; i++) {
							if (this.hbtag.indexOf(this.hball[i]) == -1) {
								this.hbtag.push(this.hball[i])
							}
						}

					}
				} else if (index == 2) {
					if (this.hnall.indexOf(val.name) == -1) {
						this.hntag.push(val.name)
						this.hnall.push(val.name)
					} else {
						this.hntag.splice(this.hntag.indexOf(val.name), 1)
						this.hnall.splice(this.hnall.indexOf(val.name), 1)
					}
					if (this.hnall.length == val2.length) {

						this.hntag = ['华南']
						this.provinceCheck.push('华南')
					} else {
						if (this.provinceCheck.indexOf('华南') != -1) {
							this.provinceCheck.splice(this.provinceCheck.indexOf('华南'), 1)
						}
						for (var i = 0; i < this.hnall.length; i++) {
							if (this.hntag.indexOf(this.hnall[i]) == -1) {
								this.hntag.push(this.hnall[i])
							}
						}

					}
				} else if (index == 3) {
					if (this.hdall.indexOf(val.name) == -1) {
						this.hdtag.push(val.name)
						this.hdall.push(val.name)
					} else {
						this.hdtag.splice(this.hdtag.indexOf(val.name), 1)
						this.hdall.splice(this.hdall.indexOf(val.name), 1)
					}
					if (this.hdall.length == val2.length) {
						this.hdtag = ['华东']
						this.provinceCheck.push('华东')
					} else {
						if (this.provinceCheck.indexOf('华东') != -1) {
							this.provinceCheck.splice(this.provinceCheck.indexOf('华东'), 1)
						}
						for (var i = 0; i < this.hdall.length; i++) {
							if (this.hdtag.indexOf(this.hdall[i]) == -1) {
								this.hdtag.push(this.hdall[i])
							}
						}

					}
				} else if (index == 4) {
					if (this.hzall.indexOf(val.name) == -1) {
						this.hztag.push(val.name)
						this.hzall.push(val.name)
					} else {
						this.hztag.splice(this.hztag.indexOf(val.name), 1)
						this.hzall.splice(this.hzall.indexOf(val.name), 1)
					}
					if (this.hzall.length == val2.length) {
						this.hztag = ['华中']
						this.provinceCheck.push('华中')
					} else {
						if (this.provinceCheck.indexOf('华中') != -1) {
							this.provinceCheck.splice(this.provinceCheck.indexOf('华中'), 1)
						}
						for (var i = 0; i < this.hzall.length; i++) {
							if (this.hztag.indexOf(this.hzall[i]) == -1) {
								this.hztag.push(this.hzall[i])
							}
						}

					}
				} else if (index == 6) {
					if (this.xball.indexOf(val.name) == -1) {
						this.xbtag.push(val.name)
						this.xball.push(val.name)
					} else {
						this.xbtag.splice(this.xbtag.indexOf(val.name), 1)
						this.xball.splice(this.xball.indexOf(val.name), 1)
					}
					if (this.xball.length == val2.length) {
						this.xbtag = ['西北']
						this.provinceCheck.push('西北')
					} else {
						if (this.provinceCheck.indexOf('西北') != -1) {
							this.provinceCheck.splice(this.provinceCheck.indexOf('西北'), 1)
						}
						for (var i = 0; i < this.xball.length; i++) {
							if (this.xbtag.indexOf(this.xball[i]) == -1) {
								this.xbtag.push(this.xball[i])
							}
						}

					}
				} else if (index == 5) {
					if (this.xnall.indexOf(val.name) == -1) {
						this.xntag.push(val.name)
						this.xnall.push(val.name)
					} else {
						this.xntag.splice(this.xntag.indexOf(val.name), 1)
						this.xnall.splice(this.xnall.indexOf(val.name), 1)
					}
					if (this.xnall.length == val2.length) {
						this.xntag = ['西南']
						this.provinceCheck.push('西南')
					} else {
						if (this.provinceCheck.indexOf('西南') != -1) {
							this.provinceCheck.splice(this.provinceCheck.indexOf('西南'), 1)
						}
						for (var i = 0; i < this.xnall.length; i++) {
							if (this.xntag.indexOf(this.xnall[i]) == -1) {
								this.xntag.push(this.xnall[i])
							}
						}

					}
				}
				//   for(var i =0;i<this.xn.length;i++){
				//      if(this.xn[i].name == val.name){
				//          if(this.xnall.indexOf(val.name) == -1){
				//              this.xntag.push(val.name)
				//              this.xnall.push(val.name)
				//          }else{
				//            this.xntag.splice(this.xntag.indexOf(val.name),1)
				//            this.xnall.splice(this.xnall.indexOf(val.name),1)
				//          }

				//           // 全选
				//         if(this.xnall.length == this.xn.length){
				//              //console.log('全选')
				//               this.xntag = ['西南']
				//               this.provinceCheck.push('西南')
				//         }else{
				//            //console.log('没全选',this.xnall.length)
				//           if(this.provinceCheck.indexOf('西南') != -1){
				//                     this.provinceCheck.splice(this.provinceCheck.indexOf('西南'),1)
				//                   }
				//                   for(var i =0;i<this.xnall.length;i++){
				//                       if(this.xntag.indexOf(this.xnall[i]) == -1){
				//                         this.xntag.push(this.xnall[i])
				//                       }
				//                   }
				//         }


				//     }


				//  }
				//   for(var i =0;i<this.xb.length;i++){
				//      if(this.xb[i].name == val.name){
				//          if(this.xball.indexOf(val.name) == -1){
				//              this.xbtag.push(val.name)
				//              this.xball.push(val.name)
				//          }else{
				//            this.xbtag.splice(this.xbtag.indexOf(val.name),1)
				//            this.xball.splice(this.xball.indexOf(val.name),1)
				//          }

				//           // 全选
				//         if(this.xball.length == this.xb.length){
				//              //console.log('全选')
				//               this.xbtag = ['西北']
				//               this.provinceCheck.push('西北')
				//         }else{
				//            //console.log('没全选',this.xball.length)
				//           if(this.provinceCheck.indexOf('西北') != -1){
				//                     this.provinceCheck.splice(this.provinceCheck.indexOf('西北'),1)
				//                   }
				//                   for(var i =0;i<this.xball.length;i++){
				//                       if(this.xbtag.indexOf(this.xball[i]) == -1){
				//                         this.xbtag.push(this.xball[i])
				//                       }
				//                   }
				//         }


				//     }


				//  }
				//   for(var i =0;i<this.hn.length;i++){
				//      if(this.hn[i].name == val.name){
				//          if(this.hnall.indexOf(val.name) == -1){
				//              this.hntag.push(val.name)
				//              this.hnall.push(val.name)
				//          }else{
				//            this.hntag.splice(this.hntag.indexOf(val.name),1)
				//            this.hnall.splice(this.hnall.indexOf(val.name),1)
				//          }

				//           // 全选
				//         if(this.hnall.length == this.hn.length){
				//              //console.log('全选')
				//               this.hntag = ['华南']
				//               this.provinceCheck.push('华南')
				//         }else{
				//            //console.log('没全选',this.hnall.length)
				//           if(this.provinceCheck.indexOf('华南') != -1){
				//                     this.provinceCheck.splice(this.provinceCheck.indexOf('华南'),1)
				//                   }
				//                   for(var i =0;i<this.hnall.length;i++){
				//                       if(this.hntag.indexOf(this.hnall[i]) == -1){
				//                         this.hntag.push(this.hnall[i])
				//                       }
				//                   }
				//         }


				//     }


				//  }
				//   for(var i =0;i<this.hb.length;i++){
				//      if(this.hb[i].name == val.name){
				//          if(this.hball.indexOf(val.name) == -1){
				//              this.hbtag.push(val.name)
				//              this.hball.push(val.name)
				//          }else{
				//            this.hbtag.splice(this.hbtag.indexOf(val.name),1)
				//            this.hball.splice(this.hball.indexOf(val.name),1)
				//          }

				//           // 全选
				//         if(this.hball.length == this.hb.length){
				//              //console.log('全选')
				//               this.hbtag = ['华北']
				//               this.provinceCheck.push('华北')
				//         }else{
				//            //console.log('没全选',this.hball.length)
				//           if(this.provinceCheck.indexOf('华北') != -1){
				//                     this.provinceCheck.splice(this.provinceCheck.indexOf('华北'),1)
				//                   }
				//                   for(var i =0;i<this.hball.length;i++){
				//                       if(this.hbtag.indexOf(this.hball[i]) == -1){
				//                         this.hbtag.push(this.hball[i])
				//                       }
				//                   }
				//         }


				//     }


				//  }
				//   for(var i =0;i<this.hz.length;i++){
				//      if(this.hz[i].name == val.name){
				//          if(this.hzall.indexOf(val.name) == -1){
				//              this.hztag.push(val.name)
				//              this.hzall.push(val.name)
				//          }else{
				//            this.hztag.splice(this.hztag.indexOf(val.name),1)
				//            this.hzall.splice(this.hzall.indexOf(val.name),1)
				//          }

				//           // 全选
				//         if(this.hzall.length == this.hz.length){
				//              //console.log('全选')
				//               this.hztag = ['华中']
				//               this.provinceCheck.push('华中')
				//         }else{
				//            //console.log('没全选',this.hzall.length)
				//           if(this.provinceCheck.indexOf('华中') != -1){
				//                     this.provinceCheck.splice(this.provinceCheck.indexOf('华中'),1)
				//                   }
				//                   for(var i =0;i<this.hzall.length;i++){
				//                       if(this.hztag.indexOf(this.hzall[i]) == -1){
				//                         this.hztag.push(this.hzall[i])
				//                       }
				//                   }
				//         }


				//     }


				//  }
				//   for(var i =0;i<this.hd.length;i++){
				//      if(this.hd[i].name == val.name){
				//          if(this.hdall.indexOf(val.name) == -1){
				//              this.hdtag.push(val.name)
				//              this.hdall.push(val.name)
				//          }else{
				//            this.hdtag.splice(this.hdtag.indexOf(val.name),1)
				//            this.hdall.splice(this.hdall.indexOf(val.name),1)
				//          }

				//           // 全选
				//         if(this.hdall.length == this.hd.length){
				//              //console.log('全选')
				//               this.hdtag = ['华东']
				//               this.provinceCheck.push('华东')
				//         }else{
				//            //console.log('没全选',this.hdall.length)
				//           if(this.provinceCheck.indexOf('华东') != -1){
				//                     this.provinceCheck.splice(this.provinceCheck.indexOf('华东'),1)
				//                   }
				//                   for(var i =0;i<this.hdall.length;i++){
				//                       if(this.hdtag.indexOf(this.hdall[i]) == -1){
				//                         this.hdtag.push(this.hdall[i])
				//                       }
				//                   }
				//         }


				//     }


				//  }
				//   for(var i =0;i<this.db.length;i++){
				//      if(this.db[i].name == val.name){
				//          if(this.dball.indexOf(val.name) == -1){
				//              this.dbtag.push(val.name)
				//              this.dball.push(val.name)
				//          }else{
				//            this.dbtag.splice(this.dbtag.indexOf(val.name),1)
				//            this.dball.splice(this.dball.indexOf(val.name),1)
				//          }

				//           // 全选
				//         if(this.dball.length == this.db.length){
				//              //console.log('全选')
				//               this.dbtag = ['东北']
				//               this.provinceCheck.push('东北')
				//         }else{
				//            //console.log('没全选',this.dball.length)
				//           if(this.provinceCheck.indexOf('东北') != -1){
				//                     this.provinceCheck.splice(this.provinceCheck.indexOf('东北'),1)
				//                   }
				//                   for(var i =0;i<this.dball.length;i++){
				//                       if(this.dbtag.indexOf(this.dball[i]) == -1){
				//                         this.dbtag.push(this.dball[i])
				//                       }
				//                   }
				//         }


				//     }


				//  }

				setTimeout(() => {
					this.getList()
				}, 100)
			},
			provinceshowFrame(item, names) {
				// provinceCheck
				// this.selectdata3 = []
				// this.provinceshowForm = item.name
				// this.provinceframeonoff = true;

				if (this.provinceCheck.indexOf('西南') != -1) {
					//console.log('2222')
					for (var i = 0; i < this.xn.length; i++) {

						if (this.xnall.indexOf(this.xn[i].name) == -1) {
							this.xnall.push(this.xn[i].name)
						} else {
							//console.log('删除西南')
						}
						//  if(this.xntag.indexOf(this.xn[i].name) == -1){
						//       this.xntag.push(this.xn[i].name)
						//   }else{
						//       this.xntag.splice(this.xntag.indexOf(this.xn[i].name) ,1)
						//   }
					}
					this.xntag = ['西南']
				} else {
					this.xntag = []
					this.xnall = []
					//console.log('取消全选西南')
					// if(this.xntag.indexOf('西南') != -1){
					//     this.xntag.splice(this.xntag.indexOf('西南'), 1)
					//      for( var i=0;i<this.xn.length;i++){
					//       this.xntag.splice(this.xntag.indexOf(this.xn[i].name), 1)
					//         //console.log('删除西南2')
					//       this.xnall.splice(this.xnall.indexOf(this.xn[i].name), 1)
					//      }
					// }
				}
				if (this.provinceCheck.indexOf('西北') != -1) {
					//console.log('2222')
					for (var i = 0; i < this.xb.length; i++) {

						if (this.xball.indexOf(this.xb[i].name) == -1) {
							this.xball.push(this.xb[i].name)
						} else {
							//console.log('删除西北')
						}
						//  if(this.xbtag.indexOf(this.xb[i].name) == -1){
						//       this.xbtag.push(this.xb[i].name)
						//   }else{
						//       this.xbtag.splice(this.xbtag.indexOf(this.xb[i].name) ,1)
						//   }
					}
					this.xbtag = ['西北']
				} else {
					this.xbtag = []
					this.xball = []
					//console.log('取消全选西北')
					// if(this.xbtag.indexOf('西北') != -1){
					//     this.xbtag.splice(this.xbtag.indexOf('西北'), 1)
					//      for( var i=0;i<this.xb.length;i++){
					//       this.xbtag.splice(this.xbtag.indexOf(this.xb[i].name), 1)
					//         //console.log('删除西北2')
					//       this.xball.splice(this.xball.indexOf(this.xb[i].name), 1)
					//      }
					// }
				}
				if (this.provinceCheck.indexOf('华南') != -1) {
					//console.log('2222')
					for (var i = 0; i < this.hn.length; i++) {
						if (this.hnall.indexOf(this.hn[i].name) == -1) {
							this.hnall.push(this.hn[i].name)
						} else {
							//console.log('删除华南')
						}
						//  if(this.hntag.indexOf(this.hn[i].name) == -1){
						//       this.hntag.push(this.hn[i].name)
						//   }else{
						//       this.hntag.splice(this.hntag.indexOf(this.hn[i].name) ,1)
						//   }
					}

					this.hntag = ['华南']
				} else {
					this.hntag = []
					this.hnall = []
					//console.log('取消全选华南')
					// if(this.hntag.indexOf('华南') != -1){
					//     this.hntag.splice(this.hntag.indexOf('华南'), 1)
					//      for( var i=0;i<this.hn.length;i++){
					//       this.hntag.splice(this.hntag.indexOf(this.hn[i].name), 1)
					//         //console.log('删除华南2')
					//       this.hnall.splice(this.hnall.indexOf(this.hn[i].name), 1)
					//      }
					// }
				}
				if (this.provinceCheck.indexOf('华北') != -1) {
					for (var i = 0; i < this.hb.length; i++) {
						if (this.hball.indexOf(this.hb[i].name) == -1) {
							this.hball.push(this.hb[i].name)
						} else {

						}
					}
					console.log('全选华北')
					this.hbtag = ['华北']

				} else {
					this.hbtag = []
					this.hball = []

				}

				if (this.provinceCheck.indexOf('华中') != -1) {
					//console.log('2222')
					for (var i = 0; i < this.hz.length; i++) {

						if (this.hzall.indexOf(this.hz[i].name) == -1) {
							this.hzall.push(this.hz[i].name)
						} else {
							//console.log('删除华中')
						}
						//  if(this.hztag.indexOf(this.hz[i].name) == -1){
						//       this.hztag.push(this.hz[i].name)
						//   }else{
						//       this.hztag.splice(this.hztag.indexOf(this.hz[i].name) ,1)
						//   }
					}
					this.hztag = ['华中']
				} else {
					this.hztag = []
					this.hzall = []
					//console.log('取消全选华中')
					// if(this.hztag.indexOf('华中') != -1){
					//     this.hztag.splice(this.hztag.indexOf('华中'), 1)
					//      for( var i=0;i<this.hz.length;i++){
					//       this.hztag.splice(this.hztag.indexOf(this.hz[i].name), 1)
					//         //console.log('删除华中2')
					//       this.hzall.splice(this.hzall.indexOf(this.hz[i].name), 1)
					//      }
					// }
				}
				if (this.provinceCheck.indexOf('华东') != -1) {
					//console.log('2222')
					for (var i = 0; i < this.hd.length; i++) {

						if (this.hdall.indexOf(this.hd[i].name) == -1) {
							this.hdall.push(this.hd[i].name)
						} else {
							//console.log('删除华东')
						}
						//  if(this.hdtag.indexOf(this.hd[i].name) == -1){
						//       this.hdtag.push(this.hd[i].name)
						//   }else{
						//       this.hdtag.splice(this.hdtag.indexOf(this.hd[i].name) ,1)
						//   }
					}
					this.hdtag = ['华东']
				} else {
					this.hdtag = []
					this.hdall = []
					//console.log('取消全选西南')
					// if(this.hdtag.indexOf('华东') != -1){
					//     this.hdtag.splice(this.hdtag.indexOf('华东'), 1)
					//      for( var i=0;i<this.hd.length;i++){
					//       this.hdtag.splice(this.hdtag.indexOf(this.hd[i].name), 1)
					//         //console.log('删除华东2')
					//       this.hdall.splice(this.hdall.indexOf(this.hd[i].name), 1)
					//      }
					// }
				}
				if (this.provinceCheck.indexOf('东北') != -1) {
					//console.log('2222')
					for (var i = 0; i < this.db.length; i++) {

						if (this.dball.indexOf(this.db[i].name) == -1) {
							this.dball.push(this.db[i].name)
						} else {
							//console.log('删除东北')
						}
						//  if(this.dbtag.indexOf(this.db[i].name) == -1){
						//       this.dbtag.push(this.db[i].name)
						//   }else{
						//       this.dbtag.splice(this.dbtag.indexOf(this.db[i].name) ,1)
						//   }
					}
					this.dbtag = ['东北']
				} else {
					this.dbtag = []
					this.dball = []

					//console.log('取消全选东北')
					// if(this.dbtag.indexOf('东北') != -1){
					//     this.dbtag.splice(this.dbtag.indexOf('东北'), 1)
					//      for( var i=0;i<this.db.length;i++){
					//       this.dbtag.splice(this.dbtag.indexOf(this.db[i].name), 1)
					//         //console.log('删除东北2')
					//       this.dball.splice(this.dball.indexOf(this.db[i].name), 1)
					//      }
					// }
				}
				setTimeout(() => {
					this.getList()
				}, 100)

				// //console.log(this.diqutag);

			},
			getChartData() {
				request('/apidfz/getChartData', {
					id: 1
				}).then(res => {
					if (res.code === 200) {
						for (let item of res.data) {
							this.chartXData.push(item.itemname)
							this.chartData.push(item.itemvalue)
						}
						this.$nextTick(() => {
							this.drawLineOne()
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
				request('/apidfz/getChartData', {
					id: 2
				}).then(res => {
					if (res.code === 200) {
						for (let item of res.data) {
							this.chartXData1.push(item.itemname)
							this.chartData1.push(item.itemvalue)
						}
						this.$nextTick(() => {
							this.drawLineOne()
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},
			drawLineOne() {
				// 基于准备好的dom，初始化echarts实例
				let myChart1 = echarts.init(document.getElementById('myChart'));
				// 绘制图表
				myChart1.setOption({
					tooltip: {
						text: '地方志收集最多的五个省份',
						formatter: this.chartData
					},
					xAxis: {
						data: this.chartXData,
						axisLabel: {
							show: true,
							textStyle: {
								color: '#5fbbb5' //这里用参数代替了
							}
						},
						axisLine: {
							lineStyle: {
								color: '#5fbbb5',
								width: 1, //这里是为了突出显示加上的
							},
						}
					},
					yAxis: [{
						type: 'value',
						// axisLabel: {
						//     formatter: this.chartData
						// }
						splitLine: {
							show: true,
							style: {
								color: '#5fbbb5'
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#5fbbb5' //这里用参数代替了
							}
						},
						axisLine: {
							lineStyle: {
								color: '#5fbbb5',
								width: 1, //这里是为了突出显示加上的
							},
						}
					}, ],
					grid: {
						left: 50
					},
					series: [{
						name: '地方志',
						type: 'bar',
						barWidth: 20,
						data: this.chartData,
						itemStyle: {
							normal: {
								color: function(params) {
									let colorList = [
										'#ff838a', '#dcee21', '#fcd357', '#f8c282', '#54bafb',
									];
									return colorList[params.dataIndex]
								},
								label: {
									show: true,
									position: 'top',
									formatter: this.chartData
								}
							}
						}

					}]
				});
				//按年代统
				let myChart2 = echarts.init(document.getElementById('barChart'));
				myChart2.setOption({
					tooltip: {
						text: '',
						formatter: this.chartData1
					},
					xAxis: {
						data: this.chartXData1,
						axisLabel: { //坐标轴刻度标签的相关设置
							interval: 0,
							rotate: "-45"
						}

					},
					yAxis: [{
						type: 'value',
						axisLabel: {
							formatter: this.chartData1
						}
					}, ],
					grid: {
						left: 50
					},
					series: [{
						name: '地方志',
						type: 'bar',
						barWidth: 20,
						data: this.chartData1,
						itemStyle: {
							normal: {
								color: function(params) {
									let colorList = [
										'#ff838a', '#dcee21', '#fcd357', '#f8c282', '#54bafb',
									];
									return colorList[params.dataIndex]
								},
								label: {
									show: true,
									position: 'top',
									formatter: this.chartData1
								}
							}
						}

					}]
				});
			},
			del(data, name) {
				let i = this[data].indexOf(name)
				this[data].splice(i, 1);
				this.getList()
			},
			toggleDateType(name) {
				this.datetype = name;
				this.getList()
			},
			//年份升序
			toggleUpbyYear(name) {
				this.yearFlag = name;
				this.getList();
			},
			//年份升序
			toggleUpbyPublicYear(name) {
				this.publicyearFlag = name;
				this.getList();
			},
			handleSizeChange(val) {
				//console.log(val);
				this.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				//console.log(val);
				this.currentPage = val;
				this.getList();
			}
		}
	};
</script>
<style scoped>
	/deep/ .DisLi .el-tag {
		border: 1px solid #cbcbcb;
		background: #FFFFFF;
		color: #9c9c9c;
		border-radius: 5px;
		font-size: 12px;
		margin-left: 5px;
		height: 20px;
		line-height: 18px;
		margin-top: 14px;
	}

	.el-table .warning-row {
		background: white;
	}

	.el-table .success-row {
		background: #EBEBEB
	}
</style>
<style>
	.el-table .warning-row {
		background: white;
	}

	.el-table .success-row {
		background: #EBEBEB
	}
</style>
<style scoped lang="less" rel="stylesheet/less">
	.el-radio {
		margin-left: 30px;
		font-size: 12px;
		padding-bottom: 15px
	}

	.el-radio__inner {
		border: 1px solid #dcdfe6;
		width: 12px;
		height: 12px;
		background-color: #fff;
		cursor: pointer;
		box-sizing: border-box;
	}

	.el-radio__label {
		font-size: 12px;
	}

	.el-radio__inner::after {
		/* width: 4px; */
		/* height: 4px; */
		/* border-radius: 100%; */
		/* background-color: #fff; */
		/* position: absolute; */
		/* left: 50%; */
		/* top: 50%; */
		/*-webkit-transform: translate(-50%,-50%) scale(0);*/
		/*transform: translate(-50%,-50%) scale(0);*/
		/*-webkit-transition: -webkit-transform .15s ease-in;*/
		/*transition: -webkit-transform .15s ease-in;*/
		/*transition: transform .15s ease-in;*/
		/*transition: transform .15s ease-in,-webkit-transform .15s ease-in;*/
	}

	.deleteAll:hover {
		cursor: pointer;
		color: red;
	}

	.itemButton {
		border: 1px solid #cbcbcb;
		background: #FFFFFF;
		color: #9c9c9c;
		border-radius: 5px;
		font-size: 12px;
		margin-left: 5px;
	}

	.itemButton:hover {
		color: red;
		cursor: pointer;
	}

	.DiFangZhiHeader span:hover {
		cursor: pointer;
	}

	.el-checkbox+.el-checkbox {
		margin: 0 10px;
	}

	.banner01 {
		// background: url('../assets/Img/banner01.jpg') no-repeat;
		background-size: cover;
	}

	.banner02 {
		// background: url('../assets/Img/banner02.png') no-repeat;
		background-size: cover;
	}

	.banner03 {
		// background: url('../assets/Img/banner03.png') no-repeat;
		background-size: cover;
	}

	.iconbase {
		width: 10px;
		height: 10px;
		background: url('../assets/Img/icon01.png') no-repeat;
		background-size: contain;
	}

	.icon02 {
		width: 10px;
		height: 10px;
		background: url('../assets/Img/icon02.png') no-repeat;
		background-size: contain;
	}

	.DiFangZhi {
		margin: 0 auto;
		width: 100%;
	}

	.DiFangZhiHeader {
		text-align: left;
		width: 12%;
		box-sizing: border-box;
		font-size: 12px;
		padding-bottom: 15px;
		padding-top: 15px;
		margin-top: 10px;
		margin-left: 10%;
	}

	.Index {
		display: flex;
		justify-content: space-between;
		width: 80%;
		box-sizing: border-box;
		margin: auto;
	}

	.IndexLeft {
		min-width: 15%;
		box-sizing: border-box;
		margin-right: 10px;
		margin-bottom: 10px;
		overflow: hidden;
	}

	.IndexLeftTitle {
		font-size: 16px;
		font-weight: bold;
		color: rgb(37, 179, 147);
		height: 50px;
		line-height: 50px;
	}

	.IndexRightafter {
		margin: 0 0 20px 20px;
		width: 250px;
	}

	.IndexRight {
		width: 755px;
		flex: 1;
		background: #ffffff;
		margin-bottom: 30px;
		/* padding: 32px 37px 36px 58px; */
		margin-top: -9px;
	}


	.IndexRightHeaderTop {
		border-bottom: 1px solid #eef2f3;
		box-sizing: border-box;
		padding: 5px 10px;
		font-weight: 300;
		color: rgba(52, 52, 52, 1);
		line-height: 30px;

		.search_header {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.right {
				display: flex;
				align-items: center;

				.icon_box {
					font-size: 14px;
					margin-left: 10px;

					.fa {
						margin-right: 5px;
					}

					>span {
						cursor: pointer;
						margin-right: 8px;
					}
				}
			}
		}
	}

	//排序
	.sortClass {
		font-size: 12px;
		margin-left: 1px;
	}

	.IndexRightHeaderTop>div {
		font-weight: 300;
		color: rgba(52, 52, 52, 1);
		font-size: 15px;
	}

	.DIming {
		margin: 10px 10px 3px 0;
	}

	.IndexRightHeaderBottom {
		font-size: 15px;
		font-weight: 300;
		width: 150px;
		line-height: 40px;
		color: rgba(52, 52, 52, 1);
	}

	.IndexRightIndex :hover {}

	.searchbtn {
		width: 60px;
		height: 40px;
		background-color: rgb(53, 202, 201);
		border-radius: 8px;
		font-size: 17px;
		font-weight: bold;
		color: rgb(255, 255, 255);
		line-height: 40px;
		text-align: center;
		cursor: pointer;
	}

	.searchbtn:hover {
		color: #eef2f3;
	}

	/* // ZUjian */
	.IndexRightIndexNeiRong {
		display: flex;
		justify-content: space-between;
		height: 130px;
		margin-top: 10px;
		background-image: url(../assets/Img/itembg.jpg);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		-moz-background-size: 100% 100%;
	}

	.IndexRightIndexNeiRong:hover {
		display: flex;
		justify-content: space-between;
		height: 130px;
		margin-top: 10px;
		background-image: url(../assets/Img/itembg.jpg);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		-moz-background-size: 100% 100%;
		outline: 1px solid #f1eeee;
	}

	.IndexRightIndexNeiRong>div:nth-child(1) {
		width: 190px;
		height: 100%;
		margin-right: 40px;
	}

	.IndexRightIndexNeiRongRight>div:nth-child(1) {
		font-size: 20px;
		/*font-family: MicrosoftYaHei;*/
		font-weight: 400;
		color: rgba(52, 52, 52, 1);
		margin: 15px 0;
		text-align: left;
	}

	.IndexRightIndexNeiRongRight>div:nth-child(2),
	.IndexRightIndexNeiRongRight>div:nth-child(3) {
		font-size: 15px;
		font-weight: 300;
		color: #ab8c4b;
		text-align: left;
		margin-top: 10px;
		margin-left: 10px;
	}

	.IndexRightIndexNeiRongRight>div:nth-child(4) {
		width: 110px;
		height: 38px;
		font-size: 16px;
		font-weight: 300;
		color: rgba(52, 52, 52, 1);
		background: #eef2f3;
		line-height: 38px;
		text-align: center;
		margin-top: 36px;
	}

	.IndexRightIndexNeiRongRightTitle {
		color: #bc8648;
	}

	.FontTitle {
		text-align: left;
		padding: 15px 10px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 13px;
	}

	/* .FontTitle > div:nth-child(2) > div {
      height: 8px;
      width: 8px;
      background: #e0e0e0;
    }
    .FontTitle > div:nth-child(2) > div:nth-child(2) {
      margin: 5px 0;
    } */

	.el-checkbox+.el-checkbox {
		font-size: 12px;
	}

	.ItemLest {
		font-size: 12px;
		text-align: left;
		display: flex;
		align-items: center;
		height: 28px;
		margin: 0 10px;
	}

	//     .ItemLest:hover {
	//         color: #409eff;
	//         background-color: #f5ebd8;
	//     }

	.ItemLest.active {
		background-color: #f5ebd8;
	}

	.BorderItem {
		height: 16px;
		width: 16px;
		background: #ffffff;
		margin-right: 20px;
	}

	.BorderItemto {
		height: 16px;
		width: 16px;
		background: #000000;
		margin-right: 20px;
	}

	.DisLi {
		position: relative;
	}

	.DisLi>.item {
		display: flex;
		flex-wrap: wrap;
	}

	.DisLi .title {
		font-size: 12px;
	}

	.frame {
		display: flex;
	}

	.frame>div {
		width: 150px;
		height: 300px;
	}

	.years {
		position: relative;
	}

	.province {
		position: relative;
	}

	.framestart {
		line-height: 28px;
		cursor: pointer;
	}

	.provinceframestart {
		line-height: 28px;
		cursor: pointer;
	}

	.no_data {
		text-align: center;
		margin: 50px 0;
	}

	.box {
		display: flex;
	}

	.lc_item {
		width: 160px;
		font-size: 12px;
		margin-left: 10px;
		cursor: pointer;
	}

	span:hover {
		color: #38afbf;
	}

	/* // ZUjian */
	.catbtn {
		width: 65px;
		height: 40px;
		background-color: rgb(53, 202, 201);
		border-radius: 8px;
		font-size: 15px;
		line-height: 40px;
		text-align: center;
		margin-top: 40px;
		cursor: pointer;
		margin-right: 40px;
		color: white;
		font-weight: bold;
	}

	.catbtn:hover {
		background-color: #11adac;
		color: #dcb7b7;
	}

	.contentitem1 {
		font-size: 13px;
		border: 1px solid #f3e7d2;
		padding: 2px 10px;
		margin-left: 3px;
		border-radius: 5px;
		max-width: 30%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.contentitem {
		font-size: 13px;
		border: 1px solid #f3e7d2;
		padding: 2px 10px;
		margin-left: 10px;
		border-radius: 5px;
	}

	.el-pagination {
		white-space: nowrap;
		padding: 2px 5px;
		color: #303133;
		font-weight: 700;
		text-align: center;
	}
</style>
